import React from "react";

export default function BrassRule({ width = 60, className = "" }) {
  return (
    <span
      aria-hidden
      className={`block mx-auto bg-brass ${className}`}
      style={{ width, height: 1, opacity: 0.85 }}
    />
  );
}
